import React from 'react';
import { toCamelCasedKeys } from '@agilepoint/utils-common';
import { useTranslate } from '@agilepoint/wat-react';
import { CenteredSpinner, ErrorInfo } from 'common';
import { IGetTextData, useGetApplicationListQuery, useSaveTextDataQuery } from 'modules/shared/queries';
import { AppList } from '../components';
interface IAppListContianerProps {
}

export const AppListContainer = React.memo((props: IAppListContianerProps) => {
    const { data, isLoading, isFetching, error } = useGetApplicationListQuery();
    const { mutateAsync, isLoading: mutationLoading } = useSaveTextDataQuery();
    const translate = useTranslate();
    const onSaveAppListDetails = React.useCallback((args: IGetTextData) => mutateAsync(args), [mutateAsync]);

    if (isLoading || isFetching) {
        return <CenteredSpinner spinnerType='indeterminate' size='small' text= {translate('modules.defaultAppSettings.appList.loadingAppListDetails')} />;
    }

    if (data) {
        const { TextData, ...rest } = data;
        const appList = JSON.parse(TextData);
        // NOTE: For backward compactability we are reading ApplicationList props, in previous releases ApplicationList is saving in api, to support this we are reading ApplicationList props.
        const applicationLists = appList.ApplicationList ? appList.ApplicationList : appList;
        const appMetadata = applicationLists.map((item: any) => toCamelCasedKeys(item));

        return (
            <AppList
                appMetadata={appMetadata}
                restAPIData={rest}
                mutationLoading={mutationLoading}
                onSaveAppListDetails={onSaveAppListDetails} />
        );
    }

    return (
        <ErrorInfo errorObject={error} />
    );
});
